import React from 'react';
import Nav from '../components/Navigation/Nav';
import Footer from '../components/Footer/Footer';
import Sidebar from '../components/Sidebar/Sidebar';
import { Outlet } from 'react-router-dom';
import "./AdminLayoutV2.css"
import NavTop from '../components/Navigation/NavTop';
import FloatingButtonWithPopup from '../components/Frontend/uiUtils/ChatboxWrapper/FloatingButtonWithPopup';

const AdminLayoutV2 = () => {
  return (
    <div className="admin-main-layout">
      <NavTop />
     
     <div className="admin-main-layout-content">
        <Sidebar />
        <div className="" style={{minWidth:"95%",maxWidth:'95%',marginLeft:"5%"}}>
          <div>
             <FloatingButtonWithPopup />
            <Outlet />
          </div>
         
        </div>
        </div>
        <Footer />
    </div>
  );
};

export default AdminLayoutV2;
